"use client";
import * as React from "react";
const SvgWifiSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m0 3.513 1.455 1.543c3.614-3.835 9.476-3.835 13.09 0L16 3.513c-4.415-4.684-11.578-4.684-16 0Zm5.818 6.172L8 12l2.182-2.315c-1.2-1.28-3.157-1.28-4.364 0ZM2.91 6.6l1.455 1.543c2.007-2.13 5.265-2.13 7.272 0L13.091 6.6c-2.807-2.978-7.367-2.978-10.182 0Z" }));
export {
  SvgWifiSharp as default
};
